var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Bldg",style:(_vm.style)},[_c('div',{staticClass:"windows"},_vm._l((_vm.windows),function(window){return _c('Window',{key:window})}),1),_c('div',{staticClass:"door",style:(_vm.doorPos)})])}
var staticRenderFns = []

export { render, staticRenderFns }